import { render, staticRenderFns } from "./SchoolStaffLeaveControl.vue?vue&type=template&id=bc459bde&scoped=true&"
import script from "./SchoolStaffLeaveControl.vue?vue&type=script&lang=js&"
export * from "./SchoolStaffLeaveControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc459bde",
  null
  
)

export default component.exports